// import Axios from 'axios'
import { GET_INFO } from './actions'

const getInfo=(data)=>dispatch=>{
  // Axios.get('infoPortafolio.json')
  // .then(res=>{
    
  // })
  return dispatch({
    type:GET_INFO,
    data:data
  })
}

export {getInfo}
